import {PlayerId} from '@glark-newco/game-library';
import type {IPointData} from '@pixi/core';
import {_ReactPixi, SimpleRope} from '@pixi/react';
import {Assets, Point, Texture} from 'pixi.js';
import {PropsWithChildren, ReactNode, useMemo} from 'react';
import {TransferRingAnimation} from './TransferRingAnimation';
import {BLUE_ROPE, PINK_ROPE} from '../assetManifest';
import {LinkRelationship, TransferRingEvent} from '../SupplyChainPayloadTypes';

interface PlayerPosition {
    playerId?: PlayerId;
    x: number;
    y: number;
}

export interface LinkSpriteProps extends PropsWithChildren<_ReactPixi.ISimpleRope> {
    relationship: LinkRelationship,
    nodeA: PlayerPosition,
    nodeB: PlayerPosition,
    activeTransfer?: TransferRingEvent;
    fromAtoB?: boolean;
}

// Don't use standalone. Use through either DesignLink or PlayLink provider.
export function LinkSprite({nodeA, nodeB, relationship, activeTransfer, fromAtoB, ...otherProps}: LinkSpriteProps): ReactNode {
    const destination = useMemo(() =>  ({x: nodeB.x, y: nodeB.y}), [nodeB.x, nodeB.y]);
    const current = useMemo(() => ({x: nodeA.x, y: nodeA.y}), [nodeA.x, nodeA.y]);

    const points: IPointData[] = useMemo(() => [
        new Point(current.x * 10, current.y * 10),
        new Point(destination.x * 10, destination.y * 10),
    ], [current.x, current.y, destination.x, destination.y]);

    const texture = Assets.get<Texture>(relationship === 'local' ? PINK_ROPE : BLUE_ROPE);

    // console.log('LinkSprite', {nodeA, nodeB, relationship, activeTransfer, fromAtoB, points});
    return (<>
        {/* 
        // @ts-expect-error types are wrong - points does exist */}
        <SimpleRope key={`${nodeA.x}-${nodeA.y}${nodeB.x}-${nodeB.y}`} texture={texture} points={points} anchor={.5} scale={.1} {...otherProps} />
        {activeTransfer && <TransferRingAnimation activeTransfer={activeTransfer} points={fromAtoB ? points : [...points].reverse()} />}
    </>);
}
